import React from "react";
import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import OurProcess from "../components/OurProcess";
import GallerySection from "../components/GallerySection";
import ContactForm from "../components/ContactForm";

const HomePage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <Hero />
      <Services />
      <WhyChooseUs />
      <OurProcess />
      <GallerySection />
      <ContactForm />
    </div>
  );
};

export default HomePage;
